import { ObjectValues } from 'types';

export const AXIOS_ERROR_IDS = {
  TIMEOUT: 'TIMEOUT',
  CANCELED: 'CANCELED',
  NETWORK_ERROR: 'NETWORK_ERROR',
  OFFLINE: 'OFFLINE',
  UNKNOWN_SERVER_ERROR: 'UNKNOWN_SERVER_ERROR',
  NON_AXIOS_ERROR: 'NON_AXIOS_ERROR',
} as const;

export type AxiosErrorId = ObjectValues<typeof AXIOS_ERROR_IDS>;

export const AXIOS_TIMEOUT_CODES = ['ECONNABORTED', 'ETIMEDOUT'];

export const AXIOS_ERROR_CODES = {
  TIMEOUT: AXIOS_TIMEOUT_CODES,
  CANCELED: 'ERR_CANCELED',
  NETWORK: 'Network Error',
} as const;

export const RETRYABLE_CODES = [
  'ECONNRESET',
  'ENOTFOUND',
  'ECONNREFUSED',
  'ERR_NETWORK',
  ...AXIOS_TIMEOUT_CODES,
] as const;

export const RETRYABLE_STATUSES = [429, 502, 503, 504];

export const MAX_RETRY_COUNT = 2;

export const RETRY_BASE_DELAY = 300;

export const IDEMPOTENT_METHODS = ['get', 'head', 'options', 'put', 'delete'];
